import angular from 'angular';
import giftNotificationHistoryComponent from './gift.notification.history.component';
export default angular.module('inv.customer.orderHistory.giftNotificationHistory', []).component('giftNotificationHistory', giftNotificationHistoryComponent).name;